export default __webpack_public_path__ + "static/media/ml1.de9f588f.png";